import React from 'react';
import Window from '../os/Window';
import { Icon } from '../general';

const BIN_ITEMS = [
    { name: 'sanity' },
    { name: 'nerves' },
    { name: 'time' },
    { name: 'decaf' },
    { name: 'sleep' },
];

const Bin: React.FC<WindowAppProps> = (props) => {
    return (
        <Window
            top={120}
            left={120}
            width={320}
            height={320}
            windowTitle="Bin"
            windowBarIcon="binIcon"
            closeWindow={props.onClose}
            onInteract={props.onInteract}
            minimizeWindow={props.onMinimize}
        >
            <div style={styles.content}>
                <p style={styles.hint}>The bin contains the following items:</p>
                <div style={styles.list}>
                    {BIN_ITEMS.map((item) => (
                        <div key={item.name} style={styles.row}>
                            <Icon
                                icon="documentIcon"
                                size={24}
                                smooth
                                style={styles.fileIcon}
                            />
                            <span style={styles.fileName}>{item.name}</span>
                        </div>
                    ))}
                </div>
            </div>
        </Window>
    );
};

const styles: StyleSheetCSS = {
    content: {
        padding: 20,
        fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, sans-serif',
        fontSize: 14,
        color: '#e8e8e8',
    },
    hint: {
        marginBottom: 12,
        color: 'rgba(255, 255, 255, 0.6)',
    },
    list: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '8px 12px',
        borderRadius: 6,
        cursor: 'default',
    },
    fileIcon: {
        flexShrink: 0,
    },
    fileName: {
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
};

export default Bin;
